const { message } = require("laravel-mix/src/Log");

document.addEventListener('DOMContentLoaded', () => {
	const bis_form = document.querySelector('form.notify-form');
	const messageContainer = document.querySelector('.pdp-sold-out-form__form .form-message');
	const klaviyoAPIKey = bis_form.getAttribute('data-klaviyo-api-key');
	const productID = bis_form.getAttribute('data-product-id');
	// console.log( 'productID', productID, ' | klaviyoAPIKey', klaviyoAPIKey );
	
	if (bis_form && messageContainer ) {
		bis_form.addEventListener('submit', (e) => {
			e.preventDefault();
			const emailInput = bis_form.querySelector('input[type="email"]');
			const notifyButton = bis_form.querySelector('button');
			notifyButton.textContent = "Sending...";
			notifyButton.disabled = true;
			const email = emailInput.value;
			
			const myHeaders = new Headers({
			"revision": "2024-07-15",
			"Content-Type": "application/json",
			"Accept": "application/json"
			});
			const raw = JSON.stringify({
			data: {
				type: "back-in-stock-subscription",
				attributes: {
				channels: ["EMAIL"],
				profile: {
					data: {
					type: "profile",
					attributes: {
						email: email
					}
					}
				}
				},
				relationships: {
				variant: {
					data: {
					type: "catalog-variant",
					id: `$shopify:::$default:::${ productID }`
					}
				}
				}
			}
			});
			
			var requestOptions = {
			method: 'POST',
			headers: myHeaders,
			body: raw,
			redirect: 'follow'
			};

			fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${ klaviyoAPIKey }`, requestOptions)
			.then(response => {
				if (response.status === 202) {
				// Display success message
					messageContainer.textContent = "Success! You will be notified when the product is back in stock.";
					emailInput.value = "";
					notifyButton.textContent = "Notify Me";
					notifyButton.disabled = false;
				} else {
					// Display error message
					messageContainer.textContent = "Error: " + data.error_message;
				}
			})
			.catch(error => {
				// Display error message if the API request fails
				messageContainer.textContent = "Error: Unable to process your request. Please try again later.";
			});
		});
	}
});